import React from "react";
import Plot from "react-plotly.js";

const ViolinPlot = ({ data, rankScore = 0, gene = '', ispp = '', type = 'variant' }) => {
  const categories = ["benign", "uncertain_significance", "pathogenic"];
  const labelMapping = {
    benign: "Benign",
    uncertain_significance: "Unknown",
    pathogenic: "Pathogenic",
  };
  console.log(data)
  if(data.benign === undefined) {
    data.benign = []
  }
  if(data.uncertain_significance === undefined) {
    data.uncertain_significance = []
  }
  if(data.pathogenic === undefined) {
    data.pathogenic = []
  }

  const plotData = categories.map((category) => ({
    type: "violin",
    y: data[category].map((value) => parseFloat(value)),
    name: labelMapping[category],
    box: { visible: true },
    meanline: { visible: true },
    points: "all",
    jitter: 0.3,
    spanmode: "hard",
    marker: {
      color:
        category === "benign" ? "teal" : category === "pathogenic" ? "red" : "orange",
    },
  }));

  const rankScoreData = {
    type: "scatter",
    x: [0, 1], // X ekseninde tam genişlik
    y: [rankScore, rankScore], // Y ekseninde belirli bir noktada sabit çizgi
    mode: "lines",
    line: {
      dash: "dash", // Kesik çizgi tipi
      width: 2,
      color: "gold",
    },
    showlegend: false,
    hovertemplate: `VoI: ${rankScore}<extra></extra>`,
    xref: "paper", // X eksenini grafiğin tamamına yay
    yref: "y", // Y ekseni veriye bağlı kalacak
  };

  return (
    <Plot
      data={[...plotData]}
      // data={[...plotData, rankScore === 0 ? [] : rankScoreData,]}
      config={{
        displaylogo: false,
      }}
      layout={{
        title: {
          text: `${type === 'variant' ? gene : `<i>${gene}</i>`} / ${ispp} `, // Başlık metni
          font: {
            size: 18, // Başlık yazı boyutu
            color: "#99a1b7", // Başlık rengi
          },
          x: 0.03, // Sol hizalama
          xanchor: "left", // Başlığın sol tarafa hizalanması
          y: 0.97, // Başlığı biraz aşağı çekmek için y değeri ayarlandı
          yanchor: "top", // Üstte hizalanması
          pad: {
            b: 15, // Başlık ile plot arasına boşluk ekleniyor
          },
        },
        width: 750, // Statik genişlik
        height: 450, // Statik yükseklik
        xaxis: {
          showticklabels: false,
          showgrid: false,
        },
        yaxis: {
          title: "Rank Score",
          zeroline: false,
          range: [0, 1],
        },
        legend: {
          orientation: "h",
          x: 0.5,
          y: -0.2,
          xanchor: "center",
        },
        showlegend: true,
        margin: {
          l: 50,
          r: 10,
          t: 50, // Üst margin artırıldı
          b: 50, // Alt margin
        },
        images: [
          {
            source: '/media/logos/vampp-logo-dark.png', // Logo URL'si (örneğin bir resim linki)
            x: 0.95, // Sağ kenara yakın konumlandırma
            y: -0.1, // Alt kenara yakın konumlandırma
            xref: "paper",
            yref: "paper",
            sizex: 0.1, // Logonun yatay boyutu
            sizey: 0.1, // Logonun dikey boyutu
            xanchor: "right",
            yanchor: "bottom",
          },
        ],
        annotations: [
          {
            text: `(Benign: ${data?.benign.length}, Unknown: ${data?.uncertain_significance.length}, Pathogenic: ${data?.pathogenic?.length})`,
            xref: "paper",
            yref: "paper",
            x: 0.5,
            y: -0.2, // Başlık aşağıda
            showarrow: false,
            font: {
              size: 12,
              color: "black",
            },
          },
        ],
        shapes: [
          {
            type: "line",
            x0: 0, x1: 1, // Tam genişlikte olması için
            y0: rankScore, y1: rankScore, // Rank Score'un olduğu yerde çizgi çizer
            xref: "paper", yref: "y", // X ekseninde tüm genişliği kaplar
            line: { color: "#101F3D", width: 2, dash: "dash" }, // Kesik çizgi
          }
        ],

      }}
    />
  );
};

export default ViolinPlot;
